import React, { useEffect } from 'react';
import { PhoneNumber } from '@/components/PhoneNumbers/PhoneNumber';
import { useOpenContacts } from '@/hooks/useOpenContacts';
import * as S from '@/components/PhoneNumbers/PhoneNumbers.styles';
import { useFloatingButtonsVisibility } from '@/hooks/useFloatingButtonsVisibility';
import { usePhoneNumbersStore } from '@/store/usePhoneNumbersStore';

interface PhoneNumbers {
  phones: string[];
  dataStat?: string;
  adId?: string;
}

const numberOnlyRegex = /^[\d\s()-]+$/;

export const PhoneNumbers: React.FC<PhoneNumbers> = ({ phones, adId }) => {
  const { getPhoneNumbers, phoneNumbers } = useOpenContacts(false);
  const removeShownNumbersAdId = usePhoneNumbersStore(
    state => state.removeShownNumbersAdId
  );
  const { isCallsAvailable } = useFloatingButtonsVisibility();

  const hasInitiallyFullNumber = !!phones.find(element =>
    numberOnlyRegex.test(element)
  );

  useEffect(() => {
    return () => {
      if (!adId) return;
      removeShownNumbersAdId(adId);
    };
  }, []);

  if (!isCallsAvailable) return null;

  return (
    <S.Box onClick={() => getPhoneNumbers({ adId })}>
      {(phoneNumbers.length ? phoneNumbers : phones).map(phone => (
        <PhoneNumber
          key={phone}
          phoneNumber={phone}
          isHidden={!hasInitiallyFullNumber && !phoneNumbers.length}
        />
      ))}
    </S.Box>
  );
};
